import type React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppContext } from '@/app/providers/AppContextProvider';
import Explainer from '@/features/Policy/components/Explainer';
import MaintenanceNotice from '@/features/Policy/components/MaintenanceNotice';
import PolicyForm from '@/features/Policy/components/Uploader';
import { MAINTENANCE_MODE } from '@/lib/maintenance';

const Policy = (): React.JSX.Element => {
	const { setAppData } = useAppContext();
	const { t } = useTranslation();

	useEffect(() => {
		setAppData(null);
	}, [setAppData]);

	return (
		<section className="flex grow items-center">
			<div className="container mx-auto px-4 xl:px-12 2xl:px-14 py-8 pb-16">
				<div className="pb-6">
					<h4 className="text-left sm:text-center text-primary text-4xl mb-5 leading-tight font-bold">
						{t(MAINTENANCE_MODE ? 'policy.upload.maintenanceTitle' : 'policy.upload.title')}
					</h4>
					<p className="text-left sm:text-center text-2xl mb-4">
						{t(MAINTENANCE_MODE ? 'policy.upload.maintenanceSubtitle' : 'policy.upload.subtitle')}
					</p>
				</div>
				<div className="w-full md:w-7/12 lg:w-7/12 xl:w-5/12 xl:px-0 mx-auto pb-18">
					{MAINTENANCE_MODE ? <MaintenanceNotice /> : <PolicyForm />}
				</div>
				<Explainer />
			</div>
		</section>
	);
};

export default Policy;
